if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        // Explicit selection (main PDP): keep an empty id input disabled so the
        // form can never submit a variant the shopper hasn't chosen.
        const explicitSelection = this.closest("[data-explicit-selection]");
        if (!explicitSelection || this.variantIdInput.value) {
          this.variantIdInput.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");



        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        // Intercept add-to-cart when the requested quantity (plus what's already
        // in the cart for this variant) would exceed the variant's sellable cap.
        // Mirrors the cart's enforcement. On the main PDP the cap + cart quantity
        // live on <product-cta>; the legacy .quantity__input is the fallback for
        // any other surface that still renders a quantity selector.
        const cta = this.closest("product-cta");
        const qtyInput = this.closest("product-info")?.querySelector(
          ".quantity__input"
        );
        const cap = parseInt(
          cta?.dataset.maximumSellableQuantity ??
            qtyInput?.dataset.maximumSellableQuantity,
          10
        );
        if (Number.isFinite(cap)) {
          const cartQty =
            parseInt(
              cta?.dataset.cartQuantity ?? qtyInput?.dataset.cartQuantity,
              10
            ) || 0;
          const requested =
            parseInt(new FormData(this.form).get("quantity"), 10) || 1;
          if (cartQty + requested > cap) {
            const template = window.cartStrings?.quantityError ?? "";
            this.handleErrorMessage(template.replace("[quantity]", cap));
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sectionIds = this.cart
            .getSectionsToRender()
            .map((section) => section.id);
          // Explicit-selection PDP: also pull the lean product-variant-data section so
          // product-info.js can refresh the island's cart quantities after the add
          // (renderContents ignores it — it isn't in getSectionsToRender).
          if (this.closest("[data-explicit-selection]")) {
            sectionIds.push("product-variant-data");
          }
          formData.append("sections", sectionIds);
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker(
                "add:wait-for-subscribers",
                startMarker
              );
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            });

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
